import { report } from '@/classes/manager/ExceptionReportingManager'
import { useAppStateStore } from '@/stores/AppStateStore'

export default async function withLoadingScreen<T>(
  promise: Promise<T>,
): Promise<T | undefined> {
  useAppStateStore().isLoading = true
  let result: T | undefined
  try {
    result = await promise
  } catch (e) {
    report(e as Error)
  } finally {
    useAppStateStore().isLoading = false
  }
  return result
}
